// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class RequestFollowup_abstract extends BaseObject {
  static $t: string = 'SagaSchema.RequestFollowup';
  $t: string = 'SagaSchema.RequestFollowup';

  public static GetMembers(): string[] {
    return ['SiteId', 'EngagementCategoryConst', 'TypeId', 'TypeIdString', 'Requested', 'Delivered', 'AssignedUnits', 'PendingUnits'];
  }

  public GetMembers(): string[] {
    return RequestFollowup_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public SiteId: number = 0;
  public EngagementCategoryConst: SagaBase.EngagementCategory;
  public TypeId: number;
  public TypeIdString: string = '';
  public Requested: number = 0;
  public Delivered: number = 0;
  public AssignedUnits: Guid[];
  public PendingUnits: any[];

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
